import { render } from "./NavigationIndex.vue?vue&type=template&id=5af2d7ac&scoped=true"
import script from "./NavigationIndex.vue?vue&type=script&lang=js"
export * from "./NavigationIndex.vue?vue&type=script&lang=js"

import "./NavigationIndex.vue?vue&type=style&index=0&id=5af2d7ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af2d7ac"]])

export default __exports__